import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'display_patient_options',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(true)
  }
}
